<template>
<div class="wrapper list_wrapper">
    <div class="container">
        404 Vue Component not found
    </div>
</div>
</template>

<script>
    export default {
        name: 'NotFound'
    }
</script>